import { cx } from '@linaria/core';
import { useRef, useState } from 'react';
import { pm2Surfaces } from '@pm2/design-tokens';
import { configureIframeExport } from '@provider/app-context';
import { CSSRefTransition, Throbber } from '@utils/react';
import { iframeCls, throbberCls, TRANSITION_DURATION_MS, wrapperCls } from './postloaded-iframe.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function PostloadedIframe(props) {
  const iframeRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const onIframeLoaded = () => {
    setLoaded(true);
    configureIframeExport(iframeRef, pm2Surfaces.primaryWithCustomColor.default);
  };
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapperCls, props.className),
    children: [props.src && /*#__PURE__*/jsx("iframe", {
      ...props,
      className: cx(iframeCls, loaded && "loaded"),
      src: props.src,
      title: props.title,
      onLoad: onIframeLoaded,
      allowFullScreen: true
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: !loaded,
      timeout: TRANSITION_DURATION_MS,
      classNames: throbberCls,
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx("span", {
        ref: ref,
        className: throbberCls,
        children: /*#__PURE__*/jsx(Throbber, {})
      })
    })]
  });
}

export { PostloadedIframe };
//# sourceMappingURL=postloaded-iframe.js.map
